<template>
  <div class="social-step-editor-sidebar-media-file">
    <social-step-editor-sidebar-media-uploading v-if="uploading" />    
    <social-step-editor-sidebar-media-preview
      v-if="image"
      :src="image"
      :error="error"
      :file-name="fileName"
      @source-error="error = false"
      @load="error = false"
      @delete="clearImage"
    />
    <social-step-editor-sidebar-media-drop :accept="accept" :uploading="uploading" @select="onSelect" />
    <shared-step-editor-input-field :input-value="image" placeholder="URL" @input="onInput" />   
    <snappy-alert v-if="error && notification" :notification="notification" @close="error=false"/>
  </div>
</template>

<script>

import SocialStepEditorSidebarMediaUploading from './SocialStepEditorSidebarMediaUploading';
import SocialStepEditorSidebarMediaPreview from './SocialStepEditorSidebarMediaPreview';
import SocialStepEditorSidebarMediaDrop from './SocialStepEditorSidebarMediaDrop';
import SharedStepEditorInputField from '../../shared/form/SharedStepEditorInputField';
import {uploadGalleryImage} from '../../../../../utility/gallery/uploadGalleryImage';
import {accept} from './accertImageTypes';
import SnappyAlert from '../../../../SnappyAlert'

export default {
  components: {  
    SocialStepEditorSidebarMediaPreview,
    SocialStepEditorSidebarMediaUploading,
    SharedStepEditorInputField,
    SocialStepEditorSidebarMediaDrop,
    SnappyAlert
  },
  props: {
    image: String,
  },
  data: () => ({
    accept: accept,
    uploading: false,
    error: false,
    fileName: '',
    message: ''
  }),
  methods: {
    clearImage() {
      this.$emit('update', '');
    },
    onSelect(file) {
      this.getSrcFromFile(file);
    },
    async getSrcFromFile(file) {
      this.uploading = true;
      try {
        const url = await uploadGalleryImage(file);
        this.uploading = false;
        this.$emit('update', url);
      } catch (error) {
        this.uploading = false;
        this.error = true;
        this.message = error.response.data.message || error.message;
        console.log(error);
        $.notify(`Error: ${this.message}`, 'error');        
      }
    },
    onInput: _.debounce(function (value) {
      this.$emit('update', value);
    }, 500),
  },
  computed: {
    notification() {
      if(this.message.includes('422')) {
        return {
          message: '<strong>Uh Oh!</strong> Your image failed to upload because it does not match the requirements. Images must be smaller than 2,000 by 2,000 pixels and they must be less than two megabytes.', 
          status: 'danger', 
          dismissible: true
        }
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.social-step-editor-sidebar-media-file {
  margin: 16px;
  display: grid;
  gap: 16px;
  padding-bottom: 20px;
}
</style>
